import React, { useState, useEffect, useRef, useContext } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "./images/logo.png";
import dropicon from "./images/dropicon.png";
import { UserContext } from "../src/store/UserContext";
import placeholder from "../src/images/user_placeholder.png"


const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileTreatmentOpen, setIsMobileTreatmentOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileUserMenuOpen, setIsMobileUserMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { userImage } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const userMenuRef = useRef(null);
  const mobileUserMenuRef = useRef(null);

  // Determine if simplified header should be shown
  const simplifiedHeader = [
    "/dashboard",
    "/profile/edit",
    "/documents",
    "/orders",
  ].includes(location.pathname);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsDropdownOpen(false);
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) setIsUserMenuOpen(false);
      if (mobileUserMenuRef.current && !mobileUserMenuRef.current.contains(event.target)) setIsMobileUserMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMobileClick = (path) => {
    setIsMobileMenuOpen(false);
    setIsMobileTreatmentOpen(false);
    setIsMobileUserMenuOpen(false);
    if (path) navigate(path);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsUserMenuOpen(false);
    setIsMobileUserMenuOpen(false);
    setIsDropdownOpen(false);
    setIsMobileMenuOpen(false);
    navigate("/auth/login");
  };

  return (
    <header className="bg-white shadow-md border-b border-[#dbe3ef]">
      <div className="max-w-7xl mx-auto flex items-center justify-between py-4 px-6 lg:px-8">
        <Link to="/">
          <img src={logo} alt="Slimming Doctor" className="h-10 w-auto" />
        </Link>

        {/* Simplified Header */}
        {isLoggedIn && simplifiedHeader && (
          <div className="relative" ref={userMenuRef}>
            <button
              className="h-10 w-10 rounded-full overflow-hidden border border-gray-200"
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
            >
              <img
                src={userImage || placeholder}
                alt="User avatar"
                className="h-12 w-12 sm:h-14 sm:w-14 rounded-full border border-gray-200 object-cover"
                style={{ imageRendering: "auto" }}
              />

            </button>
            {isUserMenuOpen && (
              <ul className="absolute right-0 mt-2 w-44 bg-white border rounded shadow-lg text-sm z-30">
                <li>
                  <button className="w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => { setIsUserMenuOpen(false); navigate("/dashboard"); }}>
                    Dashboard
                  </button>
                </li>
                <li>
                  <button className="w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => { setIsUserMenuOpen(false); navigate("/profile/edit"); }}>
                    Edit Profile
                  </button>
                </li>
                <li>
                  <button className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        )}

        {/* Full Header */}
        {!simplifiedHeader && (
          <>
            <nav className="hidden md:flex items-center space-x-12 text-[14px] text-[#556987] font-poppins">
              <Link to="/">Home</Link>
              <div className="relative" ref={dropdownRef}>
                <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center">
                  Treatment
                  <img src={dropicon} alt="dropdown arrow" className="ml-1 h-4 w-4 object-contain" />
                </button>
                {isDropdownOpen && (
                  <div className="absolute mt-2 bg-white border rounded shadow-lg w-[200px] z-20">
                    <Link to="/components/trea-injection" className="block px-4 py-2" onClick={() => setIsDropdownOpen(false)}>Treatment Injection</Link>
                    <Link to="/components/details" className="block px-4 py-2" onClick={() => setIsDropdownOpen(false)}>Details</Link>
                  </div>
                )}
              </div>
              <Link to="/components/pricing">Pricing</Link>
              <Link to="/components/about-us">About Us</Link>
            </nav>

            <div className="hidden md:flex items-center space-x-4">
              {!isLoggedIn && (
                <>
                  <button className="text-[14px] bg-[#56C7D5] text-[#F0FDF4] font-poppins px-5 py-2 rounded" onClick={() => navigate("/components/Bookappointment")}>
                    Book An Appointment
                  </button>
                  <button className="px-4 py-2 text-[14px] font-poppins border rounded text-[#556987]" onClick={() => navigate("/auth/login")}>
                    Login
                  </button>
                </>
              )}
              {isLoggedIn && (
                <div className="relative" ref={userMenuRef}>
                  <button className="h-10 w-10 rounded-full overflow-hidden border border-gray-200" onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}>
                    <img
                      src={userImage || placeholder}
                      alt="User avatar"
                      className="h-12 w-12 sm:h-14 sm:w-14 rounded-full border border-gray-200 object-cover"
                      style={{ imageRendering: "auto" }}
                    />

                  </button>
                  {isUserMenuOpen && (
                    <ul className="absolute right-0 mt-2 w-44 bg-white border rounded shadow-lg text-sm z-30">
                      <li>
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => { setIsUserMenuOpen(false); navigate("/dashboard"); }}>Dashboard</button>
                      </li>
                      <li>
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => { setIsUserMenuOpen(false); navigate("/profile/edit"); }}>Edit Profile</button>
                      </li>
                      <li>
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600" onClick={handleLogout}>Logout</button>
                      </li>
                    </ul>
                  )}
                </div>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden font-medium inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
              onClick={() => { setIsMobileMenuOpen(!isMobileMenuOpen); setIsMobileTreatmentOpen(false); setIsMobileUserMenuOpen(false); }}
            >
              {isMobileMenuOpen ? (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </>
        )}
      </div>

      {/* Mobile Menu */}
      {!simplifiedHeader && isMobileMenuOpen && (
        <div className="md:hidden border-t bg-white text-[#556987] font-poppins">
          <div className="px-6 pt-3 pb-4 space-y-2">
            <button className="block text-left w-full py-1" onClick={() => handleMobileClick("/")}>Home</button>
            <div>
              <button className="flex items-center justify-between w-full py-1" onClick={() => setIsMobileTreatmentOpen(!isMobileTreatmentOpen)}>
                <span className="text-gray-700 font-medium">Treatment</span>
                <img src={dropicon} alt="dropdown arrow" className={`ml-2 h-4 w-4 transform transition-transform ${isMobileTreatmentOpen ? "rotate-180" : ""}`} />
              </button>
              {isMobileTreatmentOpen && (
                <div className="ml-3 mt-1 space-y-1">
                  <button className="block text-left w-full text-sm" onClick={() => handleMobileClick("/components/trea-injection")}>Treatment Injection</button>
                  <button className="block text-left w-full text-sm" onClick={() => handleMobileClick("/components/details")}>Details</button>
                </div>
              )}
            </div>
            <button className="block text-left w-full py-1" onClick={() => handleMobileClick("/components/pricing")}>Pricing</button>
            <button className="block text-left w-full py-1" onClick={() => handleMobileClick("/components/about-us")}>About Us</button>

            {!isLoggedIn && (
              <>
                <button className="mt-3 h-10 w-full rounded border border-gray-200 text-center text-[14px]" onClick={() => handleMobileClick("/auth/login")}>Login</button>
                <button className="mt-3 w-full font-medium text-[14px] bg-[#56C7D5] text-[#F0FDF4] px-5 py-2 rounded" onClick={() => handleMobileClick("/components/Bookappointment")}>Book An Appointment</button>
              </>
            )}

            {isLoggedIn && (
              <div className="mt-3" ref={mobileUserMenuRef}>
                <button className="flex items-center justify-between w-full py-1" onClick={() => setIsMobileUserMenuOpen(!isMobileUserMenuOpen)}>
                  <div className="flex items-center space-x-2">
                    <img
                      src={userImage || placeholder}
                      alt="User avatar"
                      className="h-12 w-12 sm:h-14 sm:w-14 rounded-full border border-gray-200 object-cover"
                      style={{ imageRendering: "auto" }}
                    />

                    <span className="text-gray-700 font-medium">Account</span>
                  </div>
                  <img src={dropicon} alt="dropdown arrow" className={`ml-2 h-4 w-4 transform transition-transform ${isMobileUserMenuOpen ? "rotate-180" : ""}`} />
                </button>
                {isMobileUserMenuOpen && (
                  <div className="ml-3 mt-1 space-y-1">
                    <button className="block text-left w-full text-sm py-2" onClick={() => handleMobileClick("/dashboard")}>Dashboard</button>
                    <button className="block text-left w-full text-sm py-2" onClick={() => handleMobileClick("/profile/edit")}>Edit Profile</button>
                    <button className="block text-left w-full text-sm py-2 text-red-600" onClick={handleLogout}>Logout</button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
